import classNames from "classnames";
import React, { Component } from "react";
import { MainStore } from "../../stores/MainStore";
import classes from "./styles.module.scss";
//const video = require("../../assets/videos/earth_animation2_1.mp4");
const URL =
  "https://learninglab.sdabocconi.it/cs_materials/earth_animation2_1.mp4";
interface Props {
  store: MainStore;
}

class Loader extends Component<Props> {
  render() {
    const { store } = this.props;
    if (!store) return null;
    const loaderClass = classNames(
      classes.Loader,
      store.loading ? classes.OnLoad : ""
    );
    if (store.screen.isMobile) {
      setTimeout(() => {
        store.setLoading(false);
      }, 4000);
    }
    return (
      <div className={loaderClass}>
        <div className={classes.ImageContainer}>
          {store.screen.isMobile ? null : (
            // <img src={earthGlobe} alt={"loading globe"} />
            <video
              autoPlay={true}
              muted={true}
              playsInline={true}
              controls={false}
              loop={false}
              /* onEnedded={e => {
                store.setLoading(false);
              }} */
            >
              <source src={URL} type="video/mp4" />
            </video>
          )}
        </div>
      </div>
    );
  }
}
export default Loader;
